import axios, { type AxiosInstance, type AxiosResponse, type AxiosError, type InternalAxiosRequestConfig } from 'axios'
import { VITE_BASE_URL, USER_TOKEN_COOKIE_NAME } from 'config'
import Cookies from 'js-cookie'

const BASE_URL: string = `${VITE_BASE_URL}api/`
const TIMEOUT: 20000 = 20000

const myAxios: AxiosInstance = axios?.create({ baseURL: BASE_URL, timeout: TIMEOUT, headers: { 'Content-Type': 'application/json' } })

myAxios.interceptors.request.use(
  (config: InternalAxiosRequestConfig) => {
    const isFromTelegramBot: boolean = typeof window !== 'undefined' && typeof (window as any)?.TelegramWebviewProxy !== 'undefined'
    const params: URLSearchParams = new URLSearchParams(window.location.search)

    const USER_TOKEN: string =
      isFromTelegramBot && (config?.url === '/users/userme' || config?.url === '/users/register') && params.get('telegram_bot')
        ? params.get('telegram_bot') || ''
        : Cookies.get(USER_TOKEN_COOKIE_NAME) || ''

    if (USER_TOKEN) config.headers['Authorization'] = USER_TOKEN
    return config
  },
  (error) => Promise?.reject(error),
)

myAxios.interceptors.response.use(
  (response: AxiosResponse) => response,
  (error: AxiosError) => Promise?.reject(error),
)

export default myAxios